var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _vm._v("\n  " + _vm._s(_vm.sector.name) + "\n  "),
    _vm.sector.children && _vm.sector.children.length
      ? _c(
          "ul",
          _vm._l(_vm.sector.children, function (child) {
            return _c("SectorNode", { key: child.id, attrs: { sector: child } })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }